// @ts-nocheck
import { LoadingButton } from '@mui/lab';
import { Alert, Box, Button, Card, Checkbox, Container, FormControlLabel, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import HeaderWithTitle from '../../components/HeaderWithTitle';
import { callPostApi, getDlCaptcha, getVoterIdCaptcha, uploadDocGetAttributes } from '../../configs/api';
import { routes } from '../../configs/routes';

import { ArrowForwardIos as ArrowForwardIosIcon } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import ConfirmationScreen from '../../components/ConfirmationScreen';
import WebcamCapture from '../../components/Webcam';
import theme from '../../configs/theme';
import { isValidDate } from '../../helpers';
import { callSnackbar, verificationProps } from '../../wrapper';
import statesList from '../../configs/states';
import { Select, MenuItem } from '@mui/material';

// importing from CDN
const DLInstructionsImage = "https://storage.googleapis.com/indisi-images-dev/DLInstructionsImage.svg"
const DLFailedImage = "https://storage.googleapis.com/indisi-images-dev/DLFailedImage.svg"

type voterIdDataType = {
    number?: string,
    state?: string,
    captcha?: string
}

enum VOTERID_SCREENS {
    SelectVerificationType,
    fillVoterIdDetails,
    uploadVoterIdInstructions,
    uploadVoterId,
    uploadVoterIdfailed,
    ShowConfirmation
}

export default function VoterId({ onError, onSuccess, onBack, token, disclaimer, confirmationRequired }: verificationProps) {
    const styles = {
        rootContainer: { padding: '12px', height: '85vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' },
        backgroundImage: { borderRadius: '16px', backgroundColor: '#F6F7FF', height: '131px', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0 20px 0' },
        fieldLabel2: { fontSize: '12px', fontWeight: '600', lineHeight: '18px' },
        submitBtn: { width: '100%', backgroundColor: '#08315F', marginTop: '20px' },
    }

    const webCamRef = useRef<any>(null);
    const flipButtonRef = useRef<any>(null);

    const [image, setImage] = useState<string>('');
    const [screen, setScreen] = useState<VOTERID_SCREENS>(VOTERID_SCREENS.fillVoterIdDetails);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [checkedDisclaimer, setCheckedDisclaimer] = useState(false);
    const [voterIdData, setVoterIdData] = useState<voterIdDataType>({
        number: '',
        state: '',
        captcha: ''
    });
    const [confirmationData, setConfirmationData] = useState({});
    const [captchaImage, setCaptchaImage] = useState('')
    const [captchaId, setCaptchaId] = useState('')

    const captureImage = useCallback(() => {
        webCamRef.current?.click(); // base64

    }, [webCamRef]);

    const getCaptcha = async () => {
        const response = await getVoterIdCaptcha(token)
        if (response?.captcha) {
            setCaptchaImage(response?.captcha)
            setCaptchaId(response?.captchaId)
        }
    }

    useEffect(() => {
        getCaptcha()
    }, [])

    const updateVoterIdData = (data: voterIdDataType) => setVoterIdData((prev) => ({ ...prev, ...data }))

    const validateVoterId = async () => {
        if (!voterIdData.state || !voterIdData.number) {
            return;
        }

        try {
            setIsLoading(true);
            let body = {
                "voterId": voterIdData.number,
                "state": voterIdData.state,
                "captchaText": voterIdData.captcha,
                "captchaId": captchaId,
                "digiLocker": false
            }
            const res = await callPostApi(routes.voterId, "?backendConfirmationRequired=true",
                body,
                {},
                token);

            if (res?.data?.code === 0) {
                if (!confirmationRequired) {
                    submitVerification()
                    return
                }
                setConfirmationData(res?.data?.data ?? {});
                setScreen(VOTERID_SCREENS.ShowConfirmation)
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const uploadImage = async () => {
        if (!image) {
            return;
        }

        try {
            setIsLoading(true)
            let query = `?backendConfirmationRequired=true`
            const res = await uploadDocGetAttributes(routes.uploadDL, query, [image], token)
            if (res?.data?.code === 0) {
                setConfirmationData(res?.data?.data);
                setScreen(VOTERID_SCREENS.ShowConfirmation);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    const submitVerification = async () => {
        try {
            setIsLoading(true);
            const res = await callPostApi(routes.submitDlConfirmation, "", { "verificationName": "voter-id" }, {}, token);
            if (res?.data?.code === 0) {
                onSuccess('voterId', true, null, true)
            } else {
                onError('voterId', false)
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    const handleTopBackClick = useCallback(() => {
        setImage((prev) => '');
        setVoterIdData((data) => ({
            number: '',
            state: '',
            captcha: ''
        }));
        onBack();
    }, [screen]);

    return (
        <Container maxWidth="sm" sx={styles.rootContainer}>
            <HeaderWithTitle
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    height: '100%',
                    margin: 'auto',
                }}
                isBackButtonDisabled={isLoading}
                title={'Verify Voter ID'}
                onBack={handleTopBackClick}
            >
                <Box sx={{ width: '100%' }}>



                    <TabContext value={screen}>
                        <TabPanel value={VOTERID_SCREENS.fillVoterIdDetails} sx={{ padding: 0 }}>
                            <>
                                <Box sx={styles.backgroundImage}>
                                     <img src='https://storage.googleapis.com/indisi-images-dev/eci-logo.png'
                                        style={{ width: '70px', height: 'auto' }}
                                        alt="eci background"
                                    />
                                </Box>
                                <FormLabel htmlFor='dl' sx={styles.fieldLabel2}>
                                    Voter ID Number
                                </FormLabel>
                                <Box>
                                    <TextField
                                        required
                                        id="dl"
                                        sx={{ width: '100%' }}
                                        value={voterIdData.number}
                                        disabled={isLoading}
                                        onChange={(e) => updateVoterIdData({ number: e.target.value })}
                                    />
                                </Box>
                                <Box sx={{ width: '100%' }}>
                                    <FormLabel sx={styles.fieldLabel2}>
                                        State
                                    </FormLabel>
                                    {/* options states */}
                                    <Select
                                        disabled={isLoading}
                                        value={voterIdData.state}
                                        onChange={(e) => updateVoterIdData({ state: e.target.value })}
                                        sx={{ width: '100%' }}
                                    >
                                        {statesList?.map((state) => (
                                            <MenuItem key={state?.code} value={state?.name}>
                                                {state?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                {<Box>
                                    <Grid container direction="row" alignItems="center" spacing={0}>
                                        <img src={`data:image/jpeg;base64,${captchaImage}`} alt="Captcha" />
                                        <TextField
                                            required
                                            id="captcha"
                                            sx={{ width: '100%' }}
                                            value={voterIdData?.captcha}
                                            disabled={isLoading}
                                            placeholder='Enter Captcha'
                                            onChange={(e) => updateVoterIdData({ captcha: e.target.value })}
                                        />
                                    </Grid>
                                </Box>}
                            </>
                        </TabPanel>
                        <TabPanel value={VOTERID_SCREENS.uploadDLInstructions} sx={{ padding: 0 }}>
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img style={{ alignItems: 'center', maxHeight: '230px' }} src={DLInstructionsImage} alt="driving license instructions" />
                                </Box>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                        <Typography variant='h6' sx={{ lineHeight: '32px' }}>
                                            How to scan
                                        </Typography>
                                    </Box>
                                    <Typography variant='body2' color="grey1.main" sx={{ margin: 0 }}>
                                        Position your driving license in the frame and click capture to scan it for you.
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography color="secondary2.main" sx={{ margin: '6px 0px', display: 'block', fontSize: '12px', fontWeight: 600, lineHeight: '22px' }}>
                                        Tips:
                                    </Typography>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                                            <LightModeOutlinedIcon sx={{ fontSize: '12px' }} />
                                            <Typography color="grey1.main" sx={{ fontSize: '11px', lineHeight: '22px', margin: '0px' }}>
                                                Find an area with good lighting
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <RemoveRedEyeOutlinedIcon sx={{ fontSize: '12px' }} />
                                            <Typography color="grey1.main" sx={{ fontSize: '11px', lineHeight: '22px', margin: '0px' }}>The License Number and Date Of Birth should be clearly visible</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        </TabPanel>
                        <TabPanel value={VOTERID_SCREENS.uploadDLfailed} sx={{ padding: 0 }}>
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '70px 0 80px' }}>
                                    <img style={{ alignItems: 'center' }} src={DLFailedImage} alt="driving license instructions" />
                                </Box>

                                <Alert
                                    severity='error'
                                    sx={{
                                        backgroundColor: theme.palette.error.light,
                                        borderRadius: '8px',
                                        color: '#CE5945',
                                        fontSize: '13px',
                                        lineHeight: '20px',
                                        padding: '10px',
                                        '& .MuiAlert-message': {
                                            padding: 0
                                        },
                                        '& .MuiAlert-icon': {
                                            padding: 0
                                        }

                                    }}
                                    icon={<ErrorIcon sx={{ fontSize: '18px' }} />}
                                >
                                    The data cannot be retrieved from your Driving License. Please enter the details manually
                                </Alert>

                                <Button onClick={() => setScreen(VOTERID_SCREENS.fillDLDetails)} sx={{ width: '100%' }}>Enter Data manually</Button>
                            </>
                        </TabPanel>
                        <TabPanel value={VOTERID_SCREENS.uploadDL} sx={{ padding: 0 }}>
                            {image ? <img
                                src={image}
                                alt="captured"
                                style={{
                                    width: '100%',
                                }} /> :

                                <WebcamCapture
                                    setImage={setImage}
                                    buttonRef={webCamRef}
                                    flipButtonRef={flipButtonRef}
                                    aspectRatio={1.3}
                                />}
                            {<Box>
                                <Grid container direction="row" alignItems="center" spacing={0}>
                                    <img src={`data:image/jpeg;base64,${captchaImage}`} alt="Captcha" />
                                    <TextField
                                        required
                                        id="captcha"
                                        sx={{ width: '100%' }}
                                        value={voterIdData.captcha}
                                        disabled={isLoading}
                                        placeholder='Enter Captcha'
                                        onChange={(e) => updateVoterIdData({ captcha: e.target.value })}
                                    />
                                </Grid>
                            </Box>}
                        </TabPanel>
                        <TabPanel value={VOTERID_SCREENS.ShowConfirmation} sx={{ padding: 0 }}>
                            <ConfirmationScreen data={confirmationData} />
                        </TabPanel>
                    </TabContext>
                </Box>
            </HeaderWithTitle>

            <Box>
                {!([VOTERID_SCREENS.SelectVerificationType, VOTERID_SCREENS.uploadDLfailed].includes(screen)) &&
                    <FormControlLabel
                        required
                        control={<Checkbox
                            checked={checkedDisclaimer}
                            disabled={isLoading}
                            onChange={(e) => setCheckedDisclaimer(e.target.checked)} />}
                        label={<span style={{ fontSize: '12px', lineHeight: '16px' }}          >
                            {disclaimer}
                        </span>}
                    />
                }

                {screen === VOTERID_SCREENS.fillVoterIdDetails &&
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => setScreen(VOTERID_SCREENS.SelectVerificationType)}
                            disabled={isLoading}
                            sx={{ width: '100%', marginTop: '20px' }}
                        >
                            Back
                        </Button>
                        <LoadingButton
                            color="primary"
                            variant="contained"
                            loading={isLoading}
                            disabled={!checkedDisclaimer || !voterIdData.number || !voterIdData.state}
                            onClick={validateVoterId}
                            sx={styles.submitBtn}
                        >
                            Verify
                        </LoadingButton>
                    </Box>
                }

                {screen === VOTERID_SCREENS.ShowConfirmation &&
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            sx={{ width: '100%', marginTop: '20px' }}
                            disabled={isLoading}
                            onClick={() => { setImage(''); setDLData({ dob: null, number: '' }); onBack(); }}
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            disabled={!checkedDisclaimer}
                            loading={isLoading}
                            onClick={submitVerification}
                            variant="contained"
                            color="primary"
                            sx={{ width: '100%', marginTop: '20px' }}
                        >
                            Continue
                        </LoadingButton>
                    </Box>
                }
            </Box>
        </Container >
    );
}